export default __webpack_public_path__ + "static/media/cyberlabW.82845b91.png";